const COMMERCIAL_ROUTES = [
  {
    key: 'weddingSite',
    href: '/site-de-casamento',
    title: 'Site de casamento',
    description: 'Crie uma página elegante com história, fotos, local, RSVP e lista de presentes.',
  },
  {
    key: 'giftList',
    href: '/lista-de-presentes-casamento',
    title: 'Lista de presentes',
    description: 'Receba presentes online e acompanhe tudo em um painel simples para o casal.',
  },
  {
    key: 'digitalInvite',
    href: '/convite-digital-casamento',
    title: 'Convite digital',
    description: 'Compartilhe convites digitais de casamento com uma experiência bonita e prática.',
  },
  {
    key: 'saveTheDate',
    href: '/save-the-date',
    title: 'Save the Date',
    description: 'Avise seus convidados com antecedência usando um save the date online personalizado.',
  },
  {
    key: 'rsvp',
    href: '/rsvp-casamento',
    title: 'RSVP online',
    description: 'Organize confirmações de presença sem planilhas e acompanhe tudo em tempo real.',
  },
  {
    key: 'pixGift',
    href: '/presente-de-casamento-pix',
    title: 'Presentes via PIX',
    description: 'Ofereça uma experiência moderna para convidados presentearem por PIX ou cartão.',
  },
];

const DEFAULT_FAQ = [
  {
    id: 'faq-1',
    question: 'Quanto tempo leva para criar meu site de casamento?',
    answer: 'Normalmente menos de 10 minutos para publicar a primeira versão com lista, fotos, local e informações do casal.',
  },
  {
    id: 'faq-2',
    question: 'O convidado precisa criar conta para presentear?',
    answer: 'Não. O convidado acessa o link da lista e consegue concluir o presente com uma jornada simples.',
  },
  {
    id: 'faq-3',
    question: 'Existe assinatura mensal?',
    answer: 'Não. O plano é gratuito e a taxa da plataforma de 3,59% só incide em cada presente confirmado.',
  },
  {
    id: 'faq-4',
    question: 'Quais formas de pagamento estão disponíveis?',
    answer: 'Seus convidados podem pagar por PIX ou cartão de crédito, conforme disponibilidade do provedor de pagamento.',
  },
];

const BASE_CONTENT = {
  heroBadge: 'Site, lista e confirmação de presença em um só lugar',
  heroTitle: 'Crie seu site e lista de casamento em minutos',
  heroDescription:
    'Publique seu site, receba presentes e acompanhe confirmações com uma experiência simples, elegante e pronta para compartilhar.',
  heroCards: [
    {
      title: 'Templates exclusivos',
      description: 'Escolha seu estilo e publique mais rápido.',
    },
    {
      title: 'O maior site de casamentos do Brasil',
      description: 'Simples e prático como você nunca viu.',
    },
    {
      eyebrow: 'Menor taxa do BRASIL',
      title: '3,59%',
      description: 'Taxa da plataforma por presente recebido',
    },
  ],
  keywordSectionTitle: 'Soluções para cada etapa do casamento',
  keywordSectionDescription:
    'O Virei Noiva reúne site de casamento, lista de presentes, convite digital, save the date e RSVP online em uma única plataforma.',
  socialTitle: 'Casais que queriam praticidade começaram por aqui',
  socialDescription:
    'Uma experiência pensada para facilitar sua rotina antes, durante e depois da publicação do site.',
  templatesTitle: 'Escolha um template e publique mais rápido',
  templatesDescription:
    'Templates elegantes para você começar com identidade visual pronta e personalizar do seu jeito.',
  howItWorksTitle: 'Como funciona',
  howItWorksDescription:
    'Da criação do site ao recebimento dos presentes, tudo em uma jornada simples e organizada.',
  howItWorks: [
    {
      title: 'Crie seu site',
      description: 'Escolha o nome do casal, a data e o estilo visual para publicar seu espaço em poucos minutos.',
    },
    {
      title: 'Personalize sua lista',
      description: 'Organize presentes e categorias para facilitar a escolha dos convidados e valorizar seu momento.',
    },
    {
      title: 'Compartilhe com os convidados',
      description: 'Envie seu link por WhatsApp, redes sociais ou convite digital e concentre tudo em um só lugar.',
    },
    {
      title: 'Acompanhe tudo em tempo real',
      description: 'Veja confirmações, presentes e movimentações em um painel simples, elegante e fácil de acompanhar.',
    },
  ],
  benefitsTitle: 'Tudo que você precisa para organizar sem estresse',
  benefitsDescription:
    'Uma experiência pensada para facilitar sua rotina antes, durante e depois da publicação do site.',
  benefits: [
    {
      title: 'Confirmações organizadas sem planilhas',
      description: 'Acompanhe presença por convidado e tenha mais controle para organizar o grande dia com segurança.',
    },
    {
      title: 'Recebimento mais simples',
      description: 'Visualize entradas e pedidos de saque com mais clareza em um fluxo feito para reduzir dúvidas.',
    },
    {
      title: 'Checkout fácil para seus convidados',
      description: 'Ofereça uma experiência de presente rápida, intuitiva e otimizada para mobile.',
    },
    {
      title: 'Suporte humano',
      description: 'Conte com atendimento próximo para tirar dúvidas em momentos importantes da sua jornada.',
    },
  ],
  faqItems: DEFAULT_FAQ,
  ctaTitle: 'Pronta para publicar seu site de casamento',
  ctaDescription:
    'Monte sua página, organize sua lista e comece a receber presentes com uma experiência elegante para você e seus convidados.',
};

const PAGE_OVERRIDES = {
  weddingSite: {
    heroBadge: 'Site de casamento personalizado',
    heroTitle: 'Crie um site de casamento personalizado e elegante',
    heroDescription:
      'Monte um site de casamento com história do casal, fotos, local, RSVP e lista de presentes em uma página pronta para compartilhar.',
    heroCards: [
      {
        title: 'Site completo do casal',
        description: 'História, fotos, local, RSVP e lista em um só lugar.',
      },
      {
        title: 'URL fácil de compartilhar',
        description: 'Publique seu link e envie para convidados sem complicação.',
      },
      {
        eyebrow: 'Pronto para publicar',
        title: 'Em minutos',
        description: 'Crie seu site de casamento online com rapidez.',
      },
    ],
    keywordSectionTitle: 'O que um bom site de casamento precisa ter',
    keywordSectionDescription:
      'No Virei Noiva, seu site de casamento pode reunir informações do evento, confirmação de presença, lista de presentes e uma apresentação bonita do casal.',
    howItWorksTitle: 'Como criar seu site de casamento',
    howItWorksDescription:
      'Você monta sua página em poucos passos e já sai com um site de casamento online pronto para ser enviado aos convidados.',
    benefitsTitle: 'Por que criar um site de casamento no Virei Noiva',
    benefitsDescription:
      'Além de bonito, o site ajuda a centralizar tudo o que o casal precisa comunicar antes do grande dia.',
    ctaTitle: 'Crie seu site de casamento agora',
    ctaDescription:
      'Comece com um template elegante, publique seu link e concentre fotos, história, local, RSVP e presentes em um só espaço.',
    faqItems: [
      {
        id: 'faq-1',
        question: 'O que colocar em um site de casamento?',
        answer: 'Normalmente você coloca a história do casal, data, local, fotos, RSVP, lista de presentes e informações importantes para os convidados.',
      },
      ...DEFAULT_FAQ.slice(1),
    ],
  },
  giftList: {
    heroBadge: 'Lista de presentes de casamento online',
    heroTitle: 'Monte sua lista de presentes de casamento online',
    heroDescription:
      'Crie uma lista de presentes elegante para casamento, compartilhe com os convidados e acompanhe os recebimentos em um painel simples.',
    heroCards: [
      {
        title: 'Lista de presentes online',
        description: 'Ofereça uma experiência prática para convidados presentearem.',
      },
      {
        title: 'Painel financeiro do casal',
        description: 'Acompanhe recebimentos e saldo com mais clareza.',
      },
      {
        eyebrow: 'Taxa clara',
        title: '3,59%',
        description: 'Por presente confirmado na plataforma.',
      },
    ],
    keywordSectionTitle: 'Como funciona a lista de presentes do Virei Noiva',
    keywordSectionDescription:
      'Sua lista de presentes de casamento fica integrada ao site do casal, com checkout simples para convidados e acompanhamento financeiro em tempo real.',
    howItWorksTitle: 'Como montar sua lista de presentes',
    howItWorksDescription:
      'Você publica sua lista, compartilha o link e acompanha o que foi recebido sem precisar controlar tudo manualmente.',
    benefitsTitle: 'Vantagens da lista de presentes online',
    benefitsDescription:
      'A lista integrada ao site ajuda o casal a organizar melhor os presentes e dá mais praticidade para os convidados.',
    ctaTitle: 'Crie sua lista de presentes de casamento',
    ctaDescription:
      'Monte sua lista online, centralize os recebimentos e compartilhe tudo com seus convidados em poucos minutos.',
  },
  digitalInvite: {
    heroBadge: 'Convite digital de casamento',
    heroTitle: 'Crie um convite digital de casamento elegante',
    heroDescription:
      'Compartilhe seu convite digital de casamento com uma página bonita, prática e fácil de enviar por WhatsApp e redes sociais.',
    keywordSectionTitle: 'Convite digital que também organiza seu casamento',
    keywordSectionDescription:
      'Além do visual bonito, o convite digital pode direcionar o convidado para informações do evento, RSVP e lista de presentes.',
    howItWorksTitle: 'Como funciona o convite digital',
    howItWorksDescription:
      'Você cria seu site, personaliza o visual e usa o link como base para enviar convites digitais do casamento.',
    benefitsTitle: 'Por que usar convite digital de casamento',
    benefitsDescription:
      'É uma forma prática de comunicar o evento, padronizar informações e facilitar o acesso dos convidados.',
    ctaTitle: 'Crie seu convite digital agora',
    ctaDescription:
      'Publique uma página elegante para compartilhar com convidados e concentrar as informações mais importantes do casamento.',
  },
  saveTheDate: {
    heroBadge: 'Save the Date online',
    heroTitle: 'Crie um Save the Date de casamento online',
    heroDescription:
      'Avise seus convidados com antecedência usando um Save the Date online elegante, fácil de compartilhar e já conectado ao seu site.',
    keywordSectionTitle: 'Save the Date com visual bonito e link pronto',
    keywordSectionDescription:
      'Use o Virei Noiva para criar um ponto de contato inicial com convidados e depois evoluir para site completo, RSVP e lista de presentes.',
    howItWorksTitle: 'Como fazer um Save the Date online',
    howItWorksDescription:
      'Você cria o site, publica o link e já pode usar a página para antecipar a data do casamento e orientar seus convidados.',
    benefitsTitle: 'Por que usar Save the Date digital',
    benefitsDescription:
      'O Save the Date ajuda convidados a se organizarem antes e abre espaço para você centralizar comunicações futuras no mesmo link.',
    ctaTitle: 'Crie seu Save the Date',
    ctaDescription:
      'Comece a divulgar a data do casamento com um link bonito e pronto para evoluir para site completo do casal.',
  },
  rsvp: {
    heroBadge: 'RSVP casamento online',
    heroTitle: 'Organize o RSVP do casamento online',
    heroDescription:
      'Confirme presença com mais praticidade, sem planilhas, usando um RSVP online integrado ao site de casamento.',
    keywordSectionTitle: 'RSVP de casamento sem bagunça',
    keywordSectionDescription:
      'No Virei Noiva, o RSVP online ajuda o casal a controlar quem confirmou presença e manter as informações centralizadas.',
    howItWorksTitle: 'Como funciona o RSVP online',
    howItWorksDescription:
      'Seus convidados acessam o link do site e confirmam presença em um fluxo simples, enquanto você acompanha tudo no painel.',
    benefitsTitle: 'Por que usar RSVP online no casamento',
    benefitsDescription:
      'Você ganha organização, reduz mensagens espalhadas e acompanha confirmações de forma mais confiável.',
    ctaTitle: 'Ative o RSVP do seu casamento',
    ctaDescription:
      'Monte seu site de casamento com RSVP online e acompanhe confirmações em um só lugar.',
  },
  pixGift: {
    heroBadge: 'Presentes de casamento via PIX',
    heroTitle: 'Receba presentes de casamento via PIX',
    heroDescription:
      'Ofereça uma experiência moderna para convidados presentearem por PIX ou cartão em uma lista de casamento online.',
    keywordSectionTitle: 'Como funciona presente de casamento por PIX',
    keywordSectionDescription:
      'O convidado escolhe o presente e conclui o pagamento em uma jornada simples, enquanto o casal acompanha os recebimentos no painel.',
    howItWorksTitle: 'Como receber presentes via PIX',
    howItWorksDescription:
      'Você cria o site, publica sua lista e compartilha o link para convidados presentearem com praticidade.',
    benefitsTitle: 'Vantagens de receber presente por PIX',
    benefitsDescription:
      'A experiência é mais simples para o convidado e o casal acompanha os presentes com clareza em um único sistema.',
    ctaTitle: 'Ative sua lista com PIX',
    ctaDescription:
      'Crie seu site de casamento com lista de presentes via PIX e organize os recebimentos em uma plataforma pronta para compartilhar.',
  },
};

export function getMarketingPageContent(seoKey = 'home') {
  const override = PAGE_OVERRIDES[seoKey] || {};
  return {
    ...BASE_CONTENT,
    ...override,
    heroCards: override.heroCards || BASE_CONTENT.heroCards,
    howItWorks: override.howItWorks || BASE_CONTENT.howItWorks,
    benefits: override.benefits || BASE_CONTENT.benefits,
    faqItems: override.faqItems || BASE_CONTENT.faqItems,
    relatedRoutes: COMMERCIAL_ROUTES.filter((route) => route.key !== seoKey),
  };
}
